import { render } from "./LoremView.vue?vue&type=template&id=2d5456d2"
import script from "./LoremView.vue?vue&type=script&lang=js"
export * from "./LoremView.vue?vue&type=script&lang=js"

import "./LoremView.vue?vue&type=style&index=0&id=2d5456d2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__